import { HighlightedText } from 'src/shared/utils/text-highlighter/TextHighlighter'
import cls from '../styles.module.scss'

export const TextContentPt = () => {
    return (
        <HighlightedText
            text="325% de bônus + 400 GIROS GRÁTIS"
            highlights={[{ word: '325%' }, { word: '400' }]}
            breakAfterWords={['bônus']}
            className={cls.text}
        />
    )
}
